import clx from 'classnames'
import styles from './Title.css'
import Item from '../Item/Item'

const Title = ({ className, children }) => {
  return (
    <Item className={clx(styles.title, className)}>
      {children}
    </Item>
  )
}

export default Title
